// v4.14.0 — LocalPackMap : carte du Local Pack AYA (marqueurs réels, sync liste).
// Coordonnées 100% issues des données AYA — aucun faux point géographique.
import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const mkIcon = (selected, color) => L.divIcon({
  className: "aya-lp-marker",
  html: `<div style="width:${selected ? 30 : 22}px;height:${selected ? 30 : 22}px;border-radius:50%;background:${selected ? "#F97316" : (color || "#00CC6E")};border:2.5px solid #04120B;box-shadow:0 0 ${selected ? 14 : 8}px ${selected ? "rgba(249,115,22,0.8)" : (color ? "rgba(249,115,22,0.55)" : "rgba(0,255,136,0.6)")};display:grid;place-items:center;color:#04120B;font-weight:900;font-size:${selected ? 13 : 10}px;">●</div>`,
  iconSize: [selected ? 30 : 22, selected ? 30 : 22],
  iconAnchor: [selected ? 15 : 11, selected ? 15 : 11],
});

export const LocalPackMap = ({ results, selectedId, onSelect }) => {
  const mapRef = useRef(null);
  const markersRef = useRef({});
  const containerRef = useRef(null);

  useEffect(() => {
    const pts = results.filter((r) => Number.isFinite(r.lat) && Number.isFinite(r.lng));
    if (!pts.length || !containerRef.current) return undefined;
    if (!mapRef.current) {
      mapRef.current = L.map(containerRef.current, { zoomControl: false, attributionControl: false, scrollWheelZoom: false });
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19 }).addTo(mapRef.current);
    }
    const map = mapRef.current;
    Object.values(markersRef.current).forEach((m) => m.remove());
    markersRef.current = {};
    const bounds = [];
    for (const r of pts) {
      const mk = L.marker([r.lat, r.lng], { icon: mkIcon(r.id === selectedId, r.pin_color) })
        .addTo(map)
        .bindTooltip(r.name, { direction: "top", offset: [0, -10] })
        .on("click", () => onSelect?.(r.id));
      markersRef.current[r.id] = mk;
      bounds.push([r.lat, r.lng]);
    }
    if (selectedId && markersRef.current[selectedId]) {
      map.setView(markersRef.current[selectedId].getLatLng(), Math.max(map.getZoom() || 13, 14), { animate: true });
    } else {
      map.fitBounds(bounds, { padding: [34, 34], maxZoom: 15 });
    }
    return undefined;
  }, [results, selectedId, onSelect]);

  useEffect(() => () => { if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; } }, []);

  if (!results.some((r) => Number.isFinite(r.lat) && Number.isFinite(r.lng))) return null;
  return (
    <div
      ref={containerRef}
      data-testid="local-pack-map"
      style={{ height: 230, borderRadius: 16, overflow: "hidden", border: "1px solid rgba(0,255,136,0.25)", marginBottom: 14, background: "#06281A" }}
    />
  );
};
